module.exports = __webpack_public_path__ + "img/neurosymbolic_classifier.03822ada.png";